import { render, staticRenderFns } from "./AdminDataReportModalBody.vue?vue&type=template&id=5fa1e7ac&scoped=true"
import script from "./AdminDataReportModalBody.vue?vue&type=script&lang=js"
export * from "./AdminDataReportModalBody.vue?vue&type=script&lang=js"
import style0 from "./AdminDataReportModalBody.vue?vue&type=style&index=0&id=5fa1e7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa1e7ac",
  null
  
)

export default component.exports